// @ts-check

export const ROUTE_LAYOUT = 'ROUTE_LAYOUT'
export const AUTHENTICATION_REQUIRED = 'requiresAuth'
export const IS_IN_MAIN_NAV = 'showInMainNav'
export const ROUTE_NAME = 'ROUTE_NAME'
export const HIDE_TITLE_ON_MOBILE = 'HIDE_TITLE_ON_MOBILE'
